// extracted by mini-css-extract-plugin
export default {"titleColor":"QuestionnairePreview_titleColor__DxOA5","labelMaxMinColor":"QuestionnairePreview_labelMaxMinColor__YvLaS","freeTextField":"QuestionnairePreview_freeTextField__6N1Od"};